import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { evidence } from '../register-hypothesis-ras.component';

@Component({
  selector: 'evidence-form-ras',
  templateUrl: './evidence-form-ras.component.html',
  styleUrls: ['./evidence-form-ras.component.scss'],
})
export class EvidenceFormRasComponent implements OnInit {
  constructor(private readonly fb: FormBuilder) {}

  @Input() evidences: evidence[];

  @Output() evidencesChange = new EventEmitter<evidence[]>();

  form = this.fb.group({
    evidence: ['', [Validators.required]],
  });

  get isEditing() {
    return this.editingId !== null;
  }

  editingId = null;

  ngOnInit() {}

  add() {
    const value = this.form.value.evidence;

    if (this.isEditing) {
      const index = this.evidences.findIndex(
        (item) => item.id === this.editingId
      );
      this.evidences[index].evidence = value;
      this.editingId = null;
    } else {
      let item = {
        evidence: value,
        id: this.evidences.length,
      };
      this.evidences.push(item);
    }

    this.form.reset();
    this.setValues();
  }

  @Output() changeValues = new EventEmitter();

  cancelEdit() {
    this.editingId = null;
    this.form.reset();
  }

  setValues() {
    this.evidencesChange.emit(this.evidences);
    this.changeValues.emit();
  }
}
